export default function parseYoastHead(yoastHead) {
  if (!yoastHead) {
    return null;
  }

  let parser;

  const isServerSide = !(typeof window !== 'undefined');
  if (isServerSide) {
    const DOMParser = require('xmldom').DOMParser;
    parser = new DOMParser();
  } else {
    parser = new DOMParser();
  }

  const parsed = parser.parseFromString(yoastHead, 'text/html');

  const data = {};

  data.metas = Array.from(parsed.getElementsByTagName('meta'));

  const scriptContent = parsed.getElementsByTagName('script')[0];
  const jsonldGraph = scriptContent && scriptContent.innerHTML
    ? JSON.parse(scriptContent.innerHTML)
    : null;

  if (jsonldGraph) {
    data.jsonldGraph = jsonldGraph;
    jsonldGraph['@graph'].forEach((element) => {
      if (element['@type'] === 'WebPage') {
        data.title = element['name'];
        data.description = element['description'];
      }
    });
  }

  return data;
}
